import { t } from 'ember-intl';
import { HttpError } from 'core/components';

<template>
  <HttpError @code={{@controller.model.status}} as |Error|>
    <Error.LinkStandalone
      @icon="chevron-left"
      @iconPosition="leading"
      @route="cloud.orgs.detail.projects"
      @model={{@controller.orgId}}
      @text={{t "helpers.options-for-http-error.go-back"}}
      data-test-service-principals-list-error-back-to-link
    />
  </HttpError>
</template>
